import { useFeatureToggles } from './hooks/useFeatureToggles';
import { FeatureToggleHeader } from './components/FeatureToggleHeader';
import { SortableFeatureToggles } from './components/SortableFeatureToggles';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useState, useEffect } from 'react';
import { useJwtDecode } from '@/common/hooks/useJwtDecode';

const FeatureTogglePage = () => {
    const { t } = useTranslation();
    const { getUserUuidFromToken } = useJwtDecode();
    const [userUUID, setUserUUID] = useState<string | null>(null);


    useEffect(() => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            const uuid = getUserUuidFromToken(token);
            setUserUUID(uuid);
        }
    }, [getUserUuidFromToken]);

    const {
        toggles,
        isLoading,
        error,
        filters,
        handleFilterChange,
        toggleFeature,
        reorderToggle,
        isUpdating,
        isReordering,
    } = useFeatureToggles({
        currentUserUUID: userUUID || undefined
    });

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-64">
                <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
            </div>
        );
    }

    if (error) {
        return (
            <Card className="border-destructive">
                <CardHeader>
                    <CardTitle className="text-destructive">
                        {t('systemSettings.featureToggles.errors.loadError.title')}
                    </CardTitle>
                    <CardDescription>
                        {t('systemSettings.featureToggles.errors.loadError.description')}
                    </CardDescription>
                </CardHeader>
            </Card>
        );
    }

    return (
        <div className="container py-6">
            <FeatureToggleHeader
                filters={filters}
                onFilterChange={handleFilterChange}
                totalToggles={toggles.length}
                filteredToggles={toggles.length}
            />

            <SortableFeatureToggles
                toggles={toggles}
                onToggle={toggleFeature}
                onReorder={reorderToggle}
                isUpdating={isUpdating}
                isReordering={isReordering}
            />
        </div>
    );
};

export default FeatureTogglePage; 